import { render } from "./approveTrainingPlan.vue?vue&type=template&id=5b062340&scoped=true"
import script from "./approveTrainingPlan?vue&type=script&lang=js"
export * from "./approveTrainingPlan?vue&type=script&lang=js"

import "./approveTrainingPlan.vue?vue&type=style&index=0&id=5b062340&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b062340"]])

export default __exports__